// /src/api/fetchUnitsList.js
import axios from "axios";
import { ApiLink } from "../APILink/ApiLink";
import authHeader from "../Auth/authHeader";

export async function fetchArticleGroups() {
  try {
    const response = await axios.get(ApiLink.API_URL + "articlegroup", {
      headers: authHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("API fetchUnitsList error", error);
    throw error;
  }
}


export async function fetchPickArticleGroups() {
  try {
    const response = await axios.get(ApiLink.API_URL + "ArticleGroup/pick", {
      headers: authHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("API fetchUnitsList error", error);
    throw error;
  }
}